/* @flow */

export {StatusBadge} from './status-badge';
export type {Level, StatusBadgeProps} from './status-badge';
